var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:['fm-def', _vm.w100 ? 'w-100' : ''],attrs:{"type":_vm.type,"name":_vm.name,"required":_vm.required,"placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }